/** Full-width exhibitor banner with video background and overlay text. */
import { ScrollReveal } from './components/ScrollReveal';

const DEFAULT_HEADLINE_LINE_1 = '40+ brands and professionals.';
const DEFAULT_HEADLINE_LINE_2 = 'All vetted. All on ArchiPro.';
const DEFAULT_BODY_MOBILE =
    'Every exhibitor at Home Design Evening is a vetted ArchiPro member. Browse their products and portfolios on ArchiPro before the event, arrive knowing exactly who to meet.';
const DEFAULT_BODY_DESKTOP =
    'Every exhibitor at Home Design Evening is a vetted ArchiPro member. Browse their products and portfolios on ArchiPro before the event — arrive knowing exactly who to meet.';

interface ExhibitorBannerProps {
    videoSrc: string;
    isMobile?: boolean;
    headlineLine1?: string;
    headlineLine2?: string;
    bodyDesktop?: string;
    bodyMobile?: string;
}

export const ExhibitorBanner = ({
    videoSrc,
    isMobile = false,
    headlineLine1 = DEFAULT_HEADLINE_LINE_1,
    headlineLine2 = DEFAULT_HEADLINE_LINE_2,
    bodyDesktop = DEFAULT_BODY_DESKTOP,
    bodyMobile = DEFAULT_BODY_MOBILE,
}: ExhibitorBannerProps) => {
    if (isMobile) {
        return (
            <section data-testid="exhibitor-banner" className="relative w-full">
                <div className="relative h-[28.375rem] w-full bg-[#141414]">
                    <video
                        src={videoSrc}
                        className="absolute inset-0 h-full w-full object-cover"
                        autoPlay
                        muted
                        loop
                        playsInline
                    />
                    <div className="absolute inset-0 bg-black/20" />
                    <div className="absolute bottom-[2rem] left-[1.5rem]">
                        <p className="font-ghost text-[1.4375rem] leading-[0.95] tracking-[-0.02em] text-white">
                            {headlineLine1}
                        </p>
                        <p className="font-ghost text-[1.4375rem] leading-[0.95] tracking-[-0.02em] text-white">
                            {headlineLine2}
                        </p>
                    </div>
                </div>
                <div className="pt-5.75 bg-white px-[1.5rem] pb-[1.625rem]">
                    <p className="font-display text-[0.9375rem] leading-[1.36] text-[#141414]">
                        {bodyMobile}
                    </p>
                </div>
            </section>
        );
    }

    return (
        <section data-testid="exhibitor-banner" className="relative w-full">
            <div
                className="relative w-full"
                style={{
                    aspectRatio: '1920 / 1080',
                    backgroundColor: '#c4c4c4',
                }}
            >
                <video
                    src={videoSrc}
                    className="absolute inset-0 h-full w-full object-cover"
                    autoPlay
                    muted
                    loop
                    playsInline
                />
                <div
                    className="absolute bottom-[3.25rem] left-[2.875rem]"
                    style={{ maxWidth: '90%' }}
                >
                    <ScrollReveal animation="fade-up" duration={700}>
                        <p className="font-ghost text-[6rem] leading-[0.96] tracking-[-0.14rem] text-white">
                            {headlineLine1}
                        </p>
                    </ScrollReveal>
                    <ScrollReveal
                        animation="fade-up"
                        duration={700}
                        delay={120}
                    >
                        <p className="font-ghost text-[6rem] leading-[0.96] tracking-[-0.14rem] text-white">
                            {headlineLine2}
                        </p>
                    </ScrollReveal>
                </div>
            </div>

            <div className="mt-[2.25rem] px-[3.125rem]">
                <ScrollReveal animation="fade-up" duration={500} delay={200}>
                    <p
                        className="font-sans text-[2.375rem] font-medium leading-[normal] tracking-[-0.08rem] text-[#141414]"
                        style={{
                            width: '68rem',
                            maxWidth: '100%',
                        }}
                    >
                        {bodyDesktop}
                    </p>
                </ScrollReveal>
            </div>
        </section>
    );
};
